

export default [
    {
        path: '/users',
        name: 'Users',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/users/users.vue'),
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/users/show/:user_id',
        name: 'ShowUser',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/users/show.vue'),
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/users/new',
        name: 'NewUser',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/users/new.vue'),
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/users/:id/companies',
        name: 'CompaniesForUser',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/users/CompaniesForUser.vue'),
        meta: { 
            requiresAuth: true
        }
    },
]